var React = require('react');

function CircleDownloadInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"18","cy":"18","r":"18","fill":"#00114D","key":0}),React.createElement("path",{"d":"M24.63 26H11.37M18 21.155V10M23.227 16.757l-4.78 4.972a.616.616 0 0 1-.893 0l-4.781-4.972","stroke":"#fff","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","key":1})]);
}

CircleDownloadInline.defaultProps = {"width":"36","height":"36","fill":"none"};

module.exports = CircleDownloadInline;

CircleDownloadInline.default = CircleDownloadInline;
